import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const weaviate = defineConnector({
  identifier: "weaviate",
  name: "Weaviate",
  tagLine: "Open-source vector database",
  logo,
  protocol: "http",
  tags: ["ai", "data"],
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl || "https://example.weaviate.cloud"),
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your cluster details",
      items: [
        {
          kind: "markdown",
          content:
            "In the [Weaviate Cloud console](https://console.weaviate.cloud/), open your cluster and copy its **REST endpoint** and an **API key**. For a self-hosted instance, use its URL and an API key you’ve configured.",
        },
      ],
    },
    {
      title: "Enter your Weaviate details",
      items: [
        {
          kind: "url",
          label: "Instance URL",
          placeholder: "https://my-cluster.weaviate.cloud",
          required: true,
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/v1/meta`,
  },
});
